import { RentWiseLogo } from "@/components/ui/icons";

export default function Loading() {
  return (
    <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <div className="relative">
          {/* Pulse effect */}
          <div className="absolute inset-0 rounded-full bg-[var(--color-brand-soft)] animate-ping" />
          <div className="absolute inset-0 rounded-full bg-[var(--color-brand-primary)]/60 animate-pulse" />
          
          {/* Logo */}
          <div className="relative w-12 h-12 text-[var(--color-brand-primary)] animate-bounce">
            <RentWiseLogo />
          </div>
        </div>
        
        {/* Loading dots */}
        <div className="flex items-center gap-1">
          <div className="w-2 h-2 rounded-full bg-[var(--color-brand-primary)] animate-[bounce_1s_ease-in-out_infinite]" />
          <div className="w-2 h-2 rounded-full bg-[var(--color-brand-primary)] animate-[bounce_1s_ease-in-out_0.2s_infinite]" />
          <div className="w-2 h-2 rounded-full bg-[var(--color-brand-primary)] animate-[bounce_1s_ease-in-out_0.4s_infinite]" />
        </div>
      </div>
    </div>
  );
} 